module.exports = __webpack_public_path__ + "img/sjya.f2f4c4dd.png";